import React, { Component } from 'react';
import * as _ from 'lodash';
import './Sorter.scss';

const SortDirection = Object.freeze({
    None: '',
    Ascending: 'ASC',
    Descending: 'DESC'
});

export class Sorter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sortDirection: SortDirection.None
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.currentSortingKey !== this.props.currentSortingKey &&
            this.props.currentSortingKey !== this.props.sortingKey
        ) {
            this.setState({ ...this.state, sortDirection: SortDirection.None });
        }
    }

    get toggledSortDirection() {
        switch (this.state.sortDirection) {
            case SortDirection.None:
                return SortDirection.Ascending;
            case SortDirection.Ascending:
                return SortDirection.Descending;
            case SortDirection.Descending:
                return SortDirection.Ascending;
            default:
                return this.state.sortDirection;
        }
    }

    handleOnSort() {
        const { onSort } = this.props;

        const newDirection = this.toggledSortDirection;

        this.setState({
            ...this.state,
            sortDirection: newDirection
        });

        if (_.isFunction(onSort)) {
            onSort({
                sortDirection: newDirection,
                sortingKey: this.props.sortingKey
            });
        }
    }

    getArrowClass = direction =>
        this.state.sortDirection === direction ? 'selected' : '';

    render = () => {
        return (
            <div className={'sorter'} onClick={() => this.handleOnSort()}>
                <i
                    className={`material-icons ${this.getArrowClass(
                        SortDirection.Ascending
                    )}`}
                >
                    arrow_drop_up{' '}
                </i>
                <i
                    className={`material-icons ${this.getArrowClass(
                        SortDirection.Descending
                    )}`}
                >
                    arrow_drop_down{' '}
                </i>
            </div>
        );
    };
}
